import React from "react";
import type { FC } from "react";

import { Icon } from "../../../../Icon";

import type { TGlyphSizes } from "../../../../../assets/types/icons";

export const TAB_RIGHT_ICON_SIZE = "16";
const TAB_RIGHT_ICON_TEST_ID = "tab-right-icon-test-id";

export type TabRightIconProps = Partial<
    Pick<Extract<TGlyphSizes, { size: typeof TAB_RIGHT_ICON_SIZE }>, "icon">
>;

export const TabRightIcon: FC<TabRightIconProps> = ({
    icon = "glyph_down_16_20",
}) => {
    return (
        <Icon
            size={TAB_RIGHT_ICON_SIZE}
            icon={icon}
            data-tsid={TAB_RIGHT_ICON_TEST_ID}
        />
    );
};

TabRightIcon.displayName = "Tab.RightIcon";

export default TabRightIcon;
